/*
This is intentionally a JavaScript file, as it's used by Cypress as well as production code.
Cypress can't load Typescript files
*/
export function pathBuilder(config) {
  return {
    acceptTermsAndConditions: `${config.baseURI}/contract/accept-terms-and-conditions`,
    latestContract: `${config.baseURI}/contract/latest?quoteId={QuoteId}`,
    submitFaceScanData: `${config.baseURI}/vitals/capture-vitals`,
  };
}
